export const isBoolean = (value) => {
  const booleans = ['true', 'false', true, false];
  return booleans.includes(value.toLowerCase());
};
